<template>
  <div class="flex flex-row items-center justify-center my-6 mx-0">
    <vee-field v-model="time"
               type="time"
               class="text-3xl font-bold"
               name="start-time"
               id="input_cal-time"/>
  </div>
  <div class="flex flex-row items-center justify-center mx-auto mt-4 mb-8">
    <font-awesome-icon icon="fa-triangle-exclamation"/>
    <span class="text-sm pl-4">
          {{ $t('KssRuntimeComponent.startKssTrackerNote', { text: featureName }) }}
    </span>
  </div>
  <kss-recurring-task-component/>
</template>

<script>
import KssRecurringTaskComponent from '@/components/Home/KssCreator/KssRecurringTaskComponent.vue';
import { getFeatureDisplayNameOrFallback } from '@/utils/featureDisplay';

export default {
  name: 'KssRuntimeComponent',
  components: { KssRecurringTaskComponent },
  data() {
    return {
      time: `${(`0${new Date().getHours()}`).slice(-2)}:${(`0${new Date().getMinutes()}`).slice(-2)}`,
    };
  },
  computed: {
    featureName() {
      return getFeatureDisplayNameOrFallback(
        this.$store,
        'kssTracker',
        this.$t('FallbackTexts.collaborationTracker'),
        this.$i18n?.locale,
      );
    },
  },
  methods: {},
  created() {
    // Round on the next half hour
    const now = new Date();
    const currentMinutes = now.getMinutes();
    let roundedMinutes;

    if (currentMinutes < 30) {
      roundedMinutes = 30;
    } else {
      roundedMinutes = 0;
      now.setHours(now.getHours() + 1); // Increment the hour if rounding down
    }
    now.setMinutes(roundedMinutes);
    const roundedTime = `${(`0${now.getHours()}`).slice(-2)}:${(`0${now.getMinutes()}`).slice(-2)}`;
    this.time = roundedTime;
    this.$store.commit('setSelectedTime', roundedTime);
  },
  watch: {
    time(newTime) {
      this.$store.commit('setSelectedTime', newTime);
    },
  },
};
</script>
